
import { defineComponent, ref, reactive, toRefs } from "vue";
import Datepicker from "vue3-datepicker";
import { Incident } from "@/interfaces/Incident";
import { fetchIncidents } from "@/helpers/api";
import { getDateFormat } from "@/helpers/store";
import { formatTime, jsTimeToRealEpoch, timeNowAsJS, getNextDayFromDate } from "@/helpers/time";
import LoadingSpinner from "@/components/LoadingSpinner.vue";

export default defineComponent({
  components: { Datepicker, LoadingSpinner },
  name: "IncidentsPage",
  setup() {
    const state = reactive({
      incidents: [] as Incident[],
      pickerStartDate: ref(timeNowAsJS(-1)),
      pickerEndDate: ref(timeNowAsJS()),
      dateFormat: getDateFormat(),
      isLoading: true,
      firstLoad: true,
    });

    const get_incidents = async () => {
      const params = new URLSearchParams();
      params.set("Limit", "100");
      if (state.firstLoad === false) {
        if (state.pickerStartDate) {
          params.set("StartTime", jsTimeToRealEpoch(state.pickerStartDate));
        }
        if (state.pickerEndDate) {
          params.set("EndTime", jsTimeToRealEpoch(state.pickerEndDate));
        }
      }
      state.incidents = await fetchIncidents(params);
      state.isLoading = false;
      state.firstLoad = false;
    };

    const push_end_date = () => {
      if (state.pickerStartDate > state.pickerEndDate) {
        state.pickerEndDate = getNextDayFromDate(state.pickerStartDate);
      }
    };

    get_incidents();

    return {
      ...toRefs(state),
      formatTime,
      push_end_date,
      get_incidents,
    };
  },
});
